<!-- 产品信息 -->
<template>
  <div class="product-info-view">
    <p class="info-title">
      产品信息&nbsp;&nbsp;{{ companyProductResultList.length }}
    </p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="companyProductResultList"
          border
          style="width: 1010px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="productCode"
            label="产品数据编号"
            align="center"
            width="165"
          ></el-table-column>

          <el-table-column
            prop="productName"
            label="产品名称"
            align="center"
            width="199"
          ></el-table-column>

          <el-table-column
            prop="productType"
            label="产品类别"
            align="center"
            width="224"
          ></el-table-column>

          <el-table-column
            prop="productIntro"
            label="产品简介"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getCompanyProductById } from "@/api/enterprise.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      companyProductResultList: []
    };
  },
  methods: {
    getInfo() {
      getCompanyProductById({
        id: this.$route.query.companyCode
      }).then(res => {
        if (Array.isArray(res.data)) {
          this.companyProductResultList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.product-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;

    .table-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: block;
        margin-right: 4px;
        width: 7px;
        height: 7px;
        background-color: #1e9fff;
        border-radius: 50%;
      }
    }
  }
}
</style>
